import PeriodicalPayment from './periodical-payment';
export default PeriodicalPayment;
